'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from 'react';
import { inline } from '@/uiPrimitives/utility/display.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { SideOverlay } from '@/uiComposites/layout/SideOverlay';
import { stack } from '@/uiPrimitives/layout/stack';
import { gridStack } from '@/uiPrimitives/layout/gridStack';
import { box } from '@/uiPrimitives/layout/box';
import { icon } from '@/uiPrimitives/media/icon';
import { closeIcon } from '@/uiIcons/closeIcon.css';
import { position } from '@/uiPrimitives/layout/position';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { focusBox } from '@/uiPrimitives/base/focus.css';
import { textBlock } from '@/uiPrimitives/typography/text';
import { secondaryButton } from '@/uiComposites/interactive/callToAction';
import { mq640px } from '@/uiPrimitives/base/mediaQuery.definitions.css';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { pile } from '@/uiPrimitives/layout/pile';
import { useDOPRouter, useIsNavigating } from '@/globals/routing/DOPRouter';
import { translateInline } from '@/globals/translate/translateInline';
import { useMatchMedia } from '@/globals/helpers/useMatchMedia';
import { useCountSelectedFilters } from '@/sections/filter/useSelectedFilters';
export const FilterOverlayClient = t0 => {
  const $ = _c(46);
  const {
    children,
    totalResults,
    className
  } = t0;
  const [opened, setOpened] = useState(false);
  const visible = useMatchMedia(mq640px.max);
  const selectedFilterCount = useCountSelectedFilters();
  const loading = useIsNavigating();
  const router = useDOPRouter();
  let t1;
  if ($[0] !== className) {
    t1 = classes(className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpened(true);
    };
    t3 = classes(secondaryButton({}));
    t4 = addTestSelector("uiOpenFilterOverlayButton");
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translateInline({
      en: "Filters",
      nl: "Filters"
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = selectedFilterCount > 0 && `(${selectedFilterCount})`;
  let t7;
  if ($[6] !== t6) {
    t7 = <button onClick={t2} className={t3} {...t4}>{" "}{t5}{" "}{t6}</button>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = opened && visible;
  let t10;
  let t9;
  if ($[8] !== visible) {
    t9 = () => {
      if (visible) {
        setOpened(false);
      }
    };
    t10 = () => {
      if (visible) {
        setOpened(false);
      }
    };
    $[8] = visible;
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = classes(gridStack({}));
    t12 = addTestSelector("uiFilterOverlay");
    t13 = classes(gridStack({
      gap: "5 | betweenParagraphs",
      gridTemplateRows: "auto minmax(0, 1fr) auto"
    }));
    t14 = <button onClick={() => {
      setOpened(false);
    }} className={classes(box({
      backgroundColor: "positiveBlue",
      inlineSize: "3 | h1",
      blockSize: "3 | h1"
    }), pile({
      alignItems: "center",
      justifyItems: "center"
    }), position({
      position: "sticky",
      insetBlockStart: "0"
    }), focusBox)} aria-label={translateInline({
      en: "Close",
      nl: "Sluiten"
    })}><i className={classes(icon({
        icon: closeIcon,
        inlineSize: "-1 | small",
        blockSize: "-1 | small"
      }))} /></button>;
    t15 = classes(box({
      paddingInline: indentSize
    }));
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] !== children) {
    t16 = <div className={t15}>{children}</div>;
    $[16] = children;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = classes(box({
      backgroundColor: "negativeBlue",
      paddingInline: indentSize,
      paddingBlock: "3 | h1"
    }), stack({
      gap: "3 | h1"
    }), position({
      position: "sticky",
      insetBlockEnd: "0"
    }));
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== router || $[20] !== selectedFilterCount) {
    t18 = selectedFilterCount > 0 && <button onClick={() => {
      router.replace("?");
    }} className={classes(textBlock({
      capSize: "-1 | small",
      color: "positiveBlue",
      textDecorationLine: "underline"
    }))} {...addTestSelector("uiOverlayClearAllFiltersButton")}>{translateInline({
        en: "Clear all filters",
        nl: "Alle filters wissen"
      })}</button>;
    $[19] = router;
    $[20] = selectedFilterCount;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  let t20;
  let t21;
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => {
      setOpened(false);
    };
    t20 = classes(box({
      backgroundColor: "positiveBlue",
      paddingInline: indentSize,
      paddingBlock: "2 | h2"
    }), textBlock({
      capSize: "-1 | small",
      fontWeight: "bold",
      textAlign: "center"
    }));
    t21 = addTestSelector("uiShowResultsButton");
    t22 = translateInline({
      en: "View results",
      nl: "Bekijk resultaten"
    });
    $[22] = t19;
    $[23] = t20;
    $[24] = t21;
    $[25] = t22;
  } else {
    t19 = $[22];
    t20 = $[23];
    t21 = $[24];
    t22 = $[25];
  }
  let t23;
  if ($[26] !== loading) {
    t23 = classes(box({
      opacity: loading ? "0" : "1"
    }), inline);
    $[26] = loading;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  if ($[28] !== t23 || $[29] !== totalResults) {
    t24 = <button onClick={t19} className={t20} {...t21}>{t22}{" "}<span className={t23}>{totalResults}</span></button>;
    $[28] = t23;
    $[29] = totalResults;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== t18 || $[32] !== t24) {
    t25 = <div className={t17}>{t18}{t24}</div>;
    $[31] = t18;
    $[32] = t24;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  if ($[34] !== t16 || $[35] !== t25) {
    t26 = <div className={t13}>{t14}{t16}{t25}</div>;
    $[34] = t16;
    $[35] = t25;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== t10 || $[38] !== t26 || $[39] !== t8 || $[40] !== t9) {
    t27 = <SideOverlay open={t8} onClose={t9} onCancel={t10} classNameInner={t11} {...t12}>{t26}</SideOverlay>;
    $[37] = t10;
    $[38] = t26;
    $[39] = t8;
    $[40] = t9;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== t1 || $[43] !== t27 || $[44] !== t7) {
    t28 = <div className={t1}>{t7}{t27}</div>;
    $[42] = t1;
    $[43] = t27;
    $[44] = t7;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  return t28;
};